import { BehaviorSubject, Subscription, Observer, map } from 'rxjs';
import { accessTokenInfo$, isAuthorized$ } from '../oauth/oauth';
import { nodeServer } from '../constants';
import { IMember } from './member';

const memberSubject = new BehaviorSubject<IMember|null>(null);

export const memberObservable = memberSubject.asObservable();

let state: IMember | null = null;

interface IUserStore {
    init: ()=> void,
    currentState: () => IMember | null;
    subscribe2: (setState: React.Dispatch<React.SetStateAction<IMember|null>>) => Subscription,
    refresh: () => void;
    erase: () => void;
    subscribe: (x: Partial<Observer<IMember | null>> | ((value: IMember | null) => void) | undefined) => Subscription;
}

export const isAdmin$ = memberSubject.pipe(map(x=>x != null ? x.admin : false));
export const email$ = memberSubject.pipe(map(x=>x != null ? x.email : false));

export const userStore : IUserStore = {
    init: () => memberSubject.next(state),
    currentState: () => state,
    subscribe2: (setState) => memberSubject.subscribe(setState),
    refresh: () => {
        if (accessTokenInfo$.value != null && accessTokenInfo$.value.accessToken != null) {
            // var p = new URLSearchParams();
            //p.append("access_token", accessTokenInfo$.value.accessToken);
            const headers = new Headers();
            //headers.append('Content-Type', 'application/x-www-form-urlencoded');
            headers.append('Authorization', 'Bearer ' + accessTokenInfo$.value.accessToken);
            //headers.append('Authorization', 'Basic ' + btoa(OAUTH_CLIENT_USERNAME + ":" + OAUTH_CLIENT_PASSWORD));
            fetch(nodeServer + 'user', { method: 'GET', headers: headers }).then(res=>{
                if (!res.ok) {
                    throw new Error('Network response was not ok')
                }
                return res.json();                
            }).then(json=>{
                //console.log(json);
                const user = json;
                //console.log("getting new user");
                state = {...user};
                //console.log(state);
                
                memberSubject.next(state);
            });
        }
    },
    erase: () =>{
        state = null;
        memberSubject.next(state);
    },
    subscribe: (x: Partial<Observer<IMember | null>> | ((value: IMember | null) => void) | undefined) => memberSubject.subscribe(x)

};

isAuthorized$.subscribe((isAuthorized) => {
    if (isAuthorized){
        userStore.refresh();
        
    } else {
        userStore.erase();
    }
});
